import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const LoginPageCard = styled(Box)(
  ({ theme, padding }) => `
  background: ${theme.loginCard.background} !important;
  border-radius: ${theme.loginCard.borderRadius} !important;
  box-shadow: ${theme.loginCard.boxShadow} !important;
  border: 2px solid rgba(255, 255, 255, 0.50) !important;
  backdrop-filter: blur(15px) !important;
  // right: -17.5% !important;
  right: -40.5% !important;
  z-index: 999 !important;
  padding: ${padding || "7% 5%"} !important;
  position: relative !important;
  top: 10% !important;

  & .MuiTypography-h2 {
    color: ${theme.loginCard.headingColor} !important;
    font-weight: ${theme.text.fontWeights.medium} !important;
    text-align: left !important;
    font-size: ${theme.text.fontSizes["5xl"]} !important;
  }

  & .MuiTypography-h5 {
    color: ${theme.loginCard.subtitleColor} !important;
    opacity: 0.75 !important;
    text-align: left !important;
    font-size: ${theme.text.fontSizes.base} !important;
    font-weight: ${theme.text.fontWeights.light} !important;
    padding-bottom: ${theme.spacing(3)} !important;
  }

  & .MuiInputLabel-root {
    color: #252F40 !important;
    font-size: ${theme.text.fontSizes.base} !important;
    font-weight: ${theme.text.fontWeights.medium} !important;
    font-style: normal !important;
    margin-bottom: ${theme.spacing(0.8)} !important;
  }

  & .MuiOutlinedInput-root {
    border-radius: ${theme.general.borderRadius} !important;
    border: 1px solid #D2D6DA !important;
    background-color: ${theme.colors.alpha.white[100]} !important;
  }

  & .MuiLoadingButton-root {
    border: 1px solid ${theme.colors.alpha.white[100]} !important;
    font-size: ${theme.text.fontSizes.base} !important;
    font-weight: ${theme.text.fontWeights.regular} !important;
  }

  & .forgot-password-link {
    color: #111 !important;
    font-size: calc(${theme.text.fontSizes.base} - 1px) !important;
    font-weight: ${theme.text.fontWeights.regular} !important;
    text-decoration-line: underline !important;
    text-decoration-style: solid !important;
    text-decoration-skip-ink: none !important;
    text-decoration-thickness: auto !important;
    text-underline-offset: 3px !important;
    text-underline-position: from-font !important;
    letter-spacing: normal !important;
    transition: all 0.3s ease !important;

    &:hover {
      letter-spacing: 1.05px !important;
    }
  }
`
);

export default LoginPageCard;
